export default "__VITE_ASSET__05c14f9f__"